<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core"
import type { ListboxContentProps } from "reka-ui"
import { ListboxContent, useForwardProps } from "reka-ui"
import type { HTMLAttributes } from "vue"

import { cn } from "@/lib/utils"

const props = defineProps<
  ListboxContentProps & { class?: HTMLAttributes["class"] }
>()

const delegatedProps = reactiveOmit(props, "class")

const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <ListboxContent
    data-slot="command-list"
    v-bind="forwarded"
    :class="
      cn(
        'no-scrollbar max-h-72 scroll-py-1 overflow-x-hidden overflow-y-auto outline-none',
        props.class,
      )
    "
  >
    <div role="presentation">
      <slot />
    </div>
  </ListboxContent>
</template>
